import { useState, useMemo } from 'react';

export const useLocalSearch = (data) => {
    const [searchTerm, setSearchTerm] = useState("");

    const filteredData = useMemo(() => {
        if (!searchTerm) return data;
        const lowerTerm = searchTerm.toLowerCase();
        return data.filter(row => 
            Object.values(row).some(val => 
                val && String(val).toLowerCase().includes(lowerTerm)
            )
        );
    }, [data, searchTerm]);

    return { searchTerm, setSearchTerm, filteredData };
};